// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getIncentiveProgramsDetails} from '../../shared/repositories';

export const updateIncentivePrograms = (pins, dealerId) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const incentivePaylod =
                {pin: pins,
                    responsibleDealerId: dealerId};

            const payload = await getIncentiveProgramsDetails(incentivePaylod);

            dispatch({
                payload,
                property: 'incentivePrograms',
                type: actions.UPDATE_INCENTIVE_PROGRAMS_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/incentive-programs.js